angular.module('directives.dashboard').directive('widgetBody',
    ['$compile', '$uibModal',
        function ($compile, $uibModal) {
            return {
                restrict: 'E',
                templateUrl: 'directives/dashboard/widgetBody.tpl.html',
                link: function (scope, element, attrs) {
                    var newElement = angular.element(scope.item.template);
                    element.append(newElement);
                    $compile(newElement)(scope);

                    scope.close = function () {
                        scope.widgets.splice(scope.widgets.indexOf(scope.item), 1);
                    };

                    if (scope.item.setting !== undefined) {

                        var settings = JSON.parse(scope.item.setting);
                        var locationIds = settings.locationIds === undefined ? [settings] : settings.locationIds;
                        var selectedLocations = [];

                        _.forEach(scope.currentUser.locations, function(loc) {
                            if(_.some(locationIds, function(id) { return parseInt(id) === loc.id; })) {
                                selectedLocations.push(loc);
                            }
                        });

                        scope.selectedWidgetTimeFrame = settings.selectedWidgetTimeFrame ? settings.selectedWidgetTimeFrame.toString() : "0";
                        scope.selectedBusinessAreaId = settings.businessAreaId;
                        scope.selectedLocation = (selectedLocations.length) ? selectedLocations[0].locationName : '';
                        scope.selectedLocationNumber = (selectedLocations.length) ? selectedLocations[0].locationNumber : '';
                        scope.selectedLocationId = (selectedLocations.length) ? selectedLocations[0].id : NaN;
                        scope.selectedLocations = selectedLocations;
                    }

                    if (scope.item.settingController) {
                        scope.settings = function () {
                            var options = {
                                templateUrl: scope.item.settingTemplateUrl,
                                controller: scope.item.settingController,
                                scope: scope
                            };
                            $uibModal.open(options);
                        };
                    }

                    scope.iconClicked = function () {
                        // empty, don't remove it
                    };
                }
            };
        }
    ]);
